import { store } from '../../../state/store';
import { FN_GRID2D__init_possible_features } from './FN_GRID2D__init_possible_features';

export const init_grid2d_possible_features_for_all_entities = () => {
  let { slice_generation, slice_collections, slice_search } = store.getState();

  FN_GRID2D__init_possible_features(Array.from(slice_generation.user_tasks_map.values()));
  FN_GRID2D__init_possible_features(Array.from(slice_generation.generations_map.values()));
  FN_GRID2D__init_possible_features(Array.from(slice_generation.user_task_reference_entities_map.values()));

  FN_GRID2D__init_possible_features(Array.from(slice_collections.custom_collections_map.values()));

  FN_GRID2D__init_possible_features(Array.from(slice_search.search_history_map.values()));
};
